import { useState, useEffect } from "react";
import { useLang } from "../i18n";
import { colors, fontHeading } from "../theme";

function encode(data) {
  return Object.keys(data)
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
    .join("&");
}

export default function ContactForm({ cars, prefillCar }) {
  const { t } = useLang();
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", car: "", message: "" });
  const [status, setStatus] = useState("idle"); // idle | sending | done | error

  useEffect(() => {
    if (prefillCar) {
      setFormData((f) => ({ ...f, car: prefillCar }));
    }
  }, [prefillCar]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...formData }),
    })
      .then(() => setStatus("done"))
      .catch(() => setStatus("error"));
  };

  if (status === "done") {
    return (
      <div style={s.thankYou}>
        <div style={s.thankYouIcon}>✓</div>
        <h3 style={s.thankYouTitle}>{t.thankYouTitle}</h3>
        <p style={s.thankYouSub}>{t.thankYouSub}</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} name="contact" style={s.form}>
      <input type="hidden" name="form-name" value="contact" />
      <div style={s.group}>
        <label style={s.label}>{t.formName}</label>
        <input
          required
          name="name"
          type="text"
          placeholder={t.formNamePh}
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          style={s.input}
          className="form-field"
        />
      </div>
      <div style={s.group}>
        <label style={s.label}>{t.formEmail}</label>
        <input
          required
          name="email"
          type="email"
          placeholder={t.formEmailPh}
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          style={s.input}
          className="form-field"
        />
      </div>
      <div style={s.group}>
        <label style={s.label}>{t.formPhone}</label>
        <input
          required
          name="phone"
          type="tel"
          placeholder={t.formPhonePh}
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          style={s.input}
          className="form-field"
        />
      </div>
      {cars && (
        <div style={s.group}>
          <label style={s.label}>{t.formCar}</label>
          <select
            name="car"
            value={formData.car}
            onChange={(e) => setFormData({ ...formData, car: e.target.value })}
            style={{ ...s.input, appearance: "none" }}
            className="form-field"
          >
            <option value="">{t.formCarNotSure}</option>
            {cars.map((c) => (
              <option key={c.id} value={`${c.brand} ${c.model}`}>
                {c.brand} {c.model}
              </option>
            ))}
          </select>
        </div>
      )}
      <div style={s.group}>
        <label style={s.label}>{t.formMessage}</label>
        <textarea
          required
          name="message"
          placeholder={t.formMessagePh}
          rows={4}
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
          style={{ ...s.input, resize: "vertical" }}
          className="form-field"
        />
      </div>
      {status === "error" && <p style={s.errorText}>{t.formError}</p>}
      <button type="submit" style={s.submitBtn} className="btn-hover" disabled={status === "sending"}>
        {status === "sending" ? t.formSending : t.formSubmit}
      </button>
    </form>
  );
}

const s = {
  form: { display: "flex", flexDirection: "column", gap: 20 },
  group: { display: "flex", flexDirection: "column", gap: 7 },
  label: { fontSize: 11, letterSpacing: "0.08em", color: colors.muted, fontFamily: fontHeading, fontWeight: 600 },
  input: {
    background: colors.bgAlt,
    border: `1px solid ${colors.border}`,
    borderRadius: 6,
    color: colors.ink,
    padding: "12px 14px",
    fontSize: 15,
    fontFamily: fontHeading,
    outline: "none",
    transition: "border-color 0.2s, background 0.2s",
  },
  submitBtn: {
    background: colors.red,
    color: "#fff",
    border: "none",
    padding: "15px 28px",
    fontSize: 12,
    letterSpacing: "0.08em",
    cursor: "pointer",
    fontFamily: fontHeading,
    fontWeight: 700,
    borderRadius: 6,
    marginTop: 4,
  },
  errorText: { color: colors.red, fontSize: 13, margin: 0 },
  thankYou: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 280, textAlign: "center" },
  thankYouIcon: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    background: colors.red,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 22,
    marginBottom: 20,
  },
  thankYouTitle: { fontSize: 24, fontWeight: 700, color: colors.ink, margin: "0 0 10px", fontFamily: fontHeading },
  thankYouSub: { fontSize: 14, color: colors.body, lineHeight: 1.7, maxWidth: 320 },
};
